"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.skMessages = exports.mkMessages = exports.enMessages = exports.csMessages = void 0;
var cs_json_1 = require("./cs.json");
Object.defineProperty(exports, "csMessages", { enumerable: true, get: function () { return __importDefault(cs_json_1).default; } });
var en_json_1 = require("./en.json");
Object.defineProperty(exports, "enMessages", { enumerable: true, get: function () { return __importDefault(en_json_1).default; } });
var mk_json_1 = require("./mk.json");
Object.defineProperty(exports, "mkMessages", { enumerable: true, get: function () { return __importDefault(mk_json_1).default; } });
var sk_json_1 = require("./sk.json");
Object.defineProperty(exports, "skMessages", { enumerable: true, get: function () { return __importDefault(sk_json_1).default; } });
